import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_z57zpn8vpm: FaireBrandEntity = {
  token: "b_z57zpn8vpm",
  type: "brand",
  name: "Scandles",
  avatarUrl:
    "https://cdn.faire.com/fastly/bfcdffcec7173ed97ea5c5c8ce3f3285abc40d89c14cbc8c5b2bd35f05b23124.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c9d6aa900cc9597172fd66f569ee1a596273595a61ad0f3ed1f8a6cdd62512b8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bfcdffcec7173ed97ea5c5c8ce3f3285abc40d89c14cbc8c5b2bd35f05b23124.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c9d6aa900cc9597172fd66f569ee1a596273595a61ad0f3ed1f8a6cdd62512b8.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 140,
  rating: 4.9,
  reviewCount: 61,
  isTopShop: true,
  isInsider: true,
  description:
    "Wax provisions 🕯️🍊🥑🍅 🍋 🍏 🌶️ 🍐\nInspired by nature’s harvest - Hand-poured & made with soy wax and scented\n\nWelcome to Scandles, where we transform nature's bounty into a culinary symphony in wax. Our candles, inspired by the vibrant colors and shapes of farmers market fruits and vegetables, are hand-poured in Los Angeles using 100% soy wax. Vegan, cruelty-free, and non-toxic, Scandles are a sustainable choice for your home. Light up your space with the beauty and aroma of nature, beautifully captured in our unique candle creations",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:26.033Z",
    importedBy: "entity-db-cli",
  },
};
